<div class="mat-dialog-title">
  <p>Digite as informações do produto</p>
</div>

<div class="mat-dialog-content" [formGroup]="productFormGroup">
  <div class="product-container">
    <div class="input-container ean-number-container">
      <mat-label>EAN</mat-label>
      <input type="text" pattern="^[0-9]*$" placeholder="0000000000" formControlName="ean" />
    </div>
  </div>

  <div class="product-container fix-top">
    <div class="input-container number-container">
      <mat-label>Desconto de Usuário</mat-label>
      <input type="number" min="1" max="100" formControlName="userDiscount" />
    </div>

    <div class="input-container number-container">
      <mat-label>Desconto Direto</mat-label>
      <input type="number" min="1" max="100" formControlName="directDiscount" />
    </div>

    <div class="input-container number-container">
      <mat-label>Desconto Indireto</mat-label>
      <input type="number" min="1" max="100" formControlName="indirectDiscount" />
    </div>
  </div>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="cancel-btn" (click)="closeDialog()">CANCELAR</button>

  <button mat-flat-button class="confirm-btn" (click)="addProduct()">CONFIRMAR</button>
</div>
